module.exports = __webpack_public_path__ + "img/p1.9069f17a.png";